module.exports = __webpack_public_path__ + "static/media/sound.2d06c308.mp3";